import React from 'react'
import ColorScheme from './ColorScheme'
import LocationTracking from './LocationTracking'
import EnableCompass from './EnableCompass'
import EnableShakeSearch from './EnableShakeSearch'
import EnableDrawing from './EnableDrawing'
import EnableSatellite from './EnableSatellite'

const Settings = () => (
  <div className="settings">
    <ul className="settings-list">
      <ColorScheme />
      <EnableDrawing />
      <LocationTracking />
      <EnableCompass />
      <EnableShakeSearch />
      <EnableSatellite />
    </ul>
  </div>
)

export default Settings



// WEBPACK FOOTER //
// ./src/components/Elements/Sidebar/Settings/index.jsx